// Job 81 — why an invoice was archived. Preset keys rather than free text so the
// reason is filterable and reportable later; job 27 is the same complaint about
// freeform entry elsewhere in this feature.
//
// Stored as the key. The label map is exhaustive over the union, so adding a key
// without a label is a compile error rather than a blank chip in the UI.

export type ArchiveReason =
  | 'updated_invoice'
  | 'duplicate'
  | 'wrong_site'
  | 'wrong_period'
  | 'test_data'
  | 'other';

export const ARCHIVE_REASON_LABELS: Record<ArchiveReason, string> = {
  updated_invoice: 'Updated invoice received',
  duplicate: 'Duplicate',
  wrong_site: 'Wrong site',
  wrong_period: 'Wrong period',
  test_data: 'Test / junk data',
  other: 'Other',
};

// Order shown in the dropdown. `updated_invoice` leads because it is the case
// job 81 was raised for.
export const ARCHIVE_REASONS: ArchiveReason[] = [
  'updated_invoice',
  'duplicate',
  'wrong_site',
  'wrong_period',
  'test_data',
  'other',
];

export function isArchiveReason(v: unknown): v is ArchiveReason {
  return typeof v === 'string' && v in ARCHIVE_REASON_LABELS;
}

/** Label for a stored key, falling back to the key itself rather than blank. */
export function archiveReasonLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return isArchiveReason(key) ? ARCHIVE_REASON_LABELS[key] : key;
}
